export const log = (...args) => {
    // eslint-disable-next-line no-console
    console.log(...args);
};
//# sourceMappingURL=logshim.js.map